export function showInstallPrompt() {
  document.dispatchEvent(new CustomEvent('beehiiv:showInstallPrompt'));
}
